<cds-popup>
  @if (data.title) {
  <cds-popup-title>{{ data.title | lang : params }}</cds-popup-title>
  }
  <cds-popup-content>
    <div innerHtml="{{ data.message | lang : params }}"></div>
  </cds-popup-content>
  <cds-popup-actions>
    @if (!data.buttonName) {
    <cds-button [config]="agreeButtonConfig" (click)="close()">{{ 'common.close' | lang | titlecase }}</cds-button>
    } @if (data.buttonName) {
    <cds-button [config]="agreeButtonConfig" (click)="close()">{{ data.buttonName | lang }}</cds-button>
    }
  </cds-popup-actions>
</cds-popup>
